import * as Maths3 from "oc-threejs/Maths3";
import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { v2, v3 } from "oc-threejs/short3";
import { updateTeilModel } from "./pfostenFunctions";
import { ModelGhost } from "oc-jaco3d/arrangement/ModelGhost";
import { Fundament } from "./Fundament";
import { Leerrohr } from "./Leerrohr";
import { ZElement } from "./ZElement";
import { gummiPufferBreite } from "../arrangement3d/schiebetor/erzeugeSchiebetorRahmen";

export function updateSchiebetor(element: ZElement) {
  element.schiebetorTranslationsPunkt.update3d();
  element.schiebetorFixPunkt.update3d();

  element.schiebetorTranslationsPunkt.transition = element.isSchiebetor
    ? {
        duration: 1000,
        delay: 300,
        property: "position",
      }
    : undefined;
  const dreiecksBreite = element.schiebetorRahmenDef?.dreiecksBreite || 0;
  const offset = element.isAnschlagLinks ? 0 : element.breite;
  const öffnung = element.schiebetorOffen
    ? element.schiebetorRahmenDef.lichteWeite
    : gummiPufferBreite;
  element.schiebetorTranslationsPunkt.position.x = element.isSchiebetor ? öffnung : 0;
  element.schiebetorFixPunkt.position.x = element.isSchiebetor ? offset : 0;
  element.schiebetorFixPunkt.position.z = element.schiebetorZOffset;
  element.schiebetorFixPunkt.quaternion.copy(
    element.isSchiebetor && !element.isAnschlagLinks
      ? Maths3.quaternion.y180
      : Maths3.quaternion.zero
  );
  const notMirrored = element.isSchiebetorMotorseiteA;

  const updateModelTeil = ({
    objektKey,
    propertyKey = objektKey,
    condition = true,
    fn,
  }: {
    objektKey: string;
    propertyKey?: string;
    condition?: boolean;
    fn: (model: ModelGhost) => void;
  }) => {
    const objekt = APP.richMetadata.findObjektForTypeAndAuswahlwert(
      objektKey,
      element.rahmenAuswahlwert?.Key
    );
    updateTeilModel(
      element.schiebetorFixPunkt,
      element.isSchiebetor && condition,
      propertyKey as any,
      objekt?.Key,
      fn
    );
  };

  updateModelTeil({
    objektKey: "Schiebetor_Auflaufschuh",
    fn: (model) => {
      model.position.y = 0;
    },
  });

  updateModelTeil({
    objektKey: "Schiebetor_Einlaufgabel",
    fn: (model) => {
      model.position.y = element.höhe - 0.05;
    },
  });

  updateModelTeil({
    objektKey: "Schiebetor_Rollenbock",
    propertyKey: "Schiebetor_Rollenbock2",
    fn: (model) => {
      model.position.x = element.breite + dreiecksBreite * 0.8;
      model.position.y = -element.positionY;
    },
  });

  updateModelTeil({
    objektKey: "Schiebetor_Entlastungsrolle",
    fn: (model) => {
      model.position.x = element.breite + dreiecksBreite * 1.8;
      model.position.y = -element.positionY;
    },
  });

  const eAntriebPosition = v3(
    element.breite + 0.3,
    -element.positionY,
    (notMirrored ? -1 : +1) * 0.16
  );

  updateModelTeil({
    objektKey: "Schiebetor_Rollenbock",
    propertyKey: "Schiebetor_Rollenbock1",
    fn: (model) => {
      model.position.x = eAntriebPosition.x;
      model.position.y = -element.positionY;
    },
  });

  updateModelTeil({
    objektKey: "Schiebetor_EAntrieb_Came",
    fn: (model) => {
      model.position.copy(eAntriebPosition);
      model.position.y += 0.15;
    },
  });
  updateModelTeil({
    objektKey: "Schiebetor_EAntrieb_Unterbau",
    fn: (model) => {
      model.position.copy(eAntriebPosition);
    },
  });

  const lichtschranken_y = 0.4;
  const schloss_x = -0.05;
  const doppelpfosten_x = element.breite;
  const rz = notMirrored ? [0.0875, -0.15] : [-0.0875, 0.15];
  const lz = notMirrored ? [-0.0875, 0.1125] : [0.0875, -0.1125];

  updateModelTeil({
    objektKey: "Schiebetor_EAntrieb_Came",
    fn: (model) => {
      model.position.copy(eAntriebPosition);
      model.position.y += 0.15;
    },
  });

  updateModelTeil({
    objektKey: "Schiebetor_Lichtschranke",
    propertyKey: "Schiebetor_Lichtschranke_l1",
    fn: (model) => {
      model.position.x = schloss_x;
      model.position.z = lz[0];
      model.quaternion.copy(notMirrored ? Maths3.quaternion.y180 : Maths3.quaternion.zero);
      model.position.y = lichtschranken_y;
    },
  });

  updateModelTeil({
    objektKey: "Schiebetor_Lichtschranke",
    propertyKey: "Schiebetor_Lichtschranke_l2",
    fn: (model) => {
      model.position.x = schloss_x;
      model.position.z = lz[1];
      model.quaternion.copy(notMirrored ? Maths3.quaternion.zero : Maths3.quaternion.y180);
      model.position.y = lichtschranken_y;
    },
  });

  updateModelTeil({
    objektKey: "Schiebetor_Lichtschranke",
    propertyKey: "Schiebetor_Lichtschranke_r1",
    fn: (model) => {
      model.position.x = doppelpfosten_x;
      model.position.z = rz[0];
      model.quaternion.copy(Maths3.quaternion.y270);
      model.position.y = lichtschranken_y;
    },
  });

  updateModelTeil({
    objektKey: "Schiebetor_Lichtschranke",
    propertyKey: "Schiebetor_Lichtschranke_r2",
    fn: (model) => {
      model.position.x = doppelpfosten_x;
      model.position.z = rz[1];
      model.quaternion.copy(Maths3.quaternion.y270);
      model.position.y = lichtschranken_y;
    },
  });

  type Ctor<T> = new (parent: Jaco) => T;
  const updateGenericTeil = <T>(propertyKey: string, clazz: Ctor<T>, update: (part: T) => void) => {
    const p = element.schiebetorFixPunkt;
    if (element.isSchiebetor) {
      const part = (p[propertyKey] = p[propertyKey] ?? new clazz(p));
      update(part);
      part.position.y = -element.positionY;
      part.update3d();
    } else {
      p[propertyKey] = null;
    }
  };

  const mirrorZ = notMirrored ? 1 : -1;

  updateGenericTeil("Schiebetor_Fundament1", Fundament, (fundament: Fundament) => {
    const w = 1.25;
    const dy = +0.2;
    const einzelfostenX = schloss_x;
    fundament.points = [v2(0, 0), v2(1, 0), v2(1, 1), v2(0, 1)].map((p) =>
      p
        .multiply(v2(w, -w))
        .add(v2(einzelfostenX - w / 2, dy))
        .multiply(v2(1, mirrorZ))
    );
    fundament.tiefe = 0.7;
    fundament.bodenAbstand = -0.1;
  });

  updateGenericTeil("Schiebetor_Fundament2", Fundament, (fundament: Fundament) => {
    const b = element.breite;
    const w1 = 1.4;
    const w2 = 2.338;
    const h1 = -0.7;
    const h2 = -1.4;
    fundament.points = [v2(0, 0), v2(w2, 0), v2(w2, h1), v2(w1, h1), v2(w1, h2), v2(0, h2)].map(
      (p) => p.add(v2(b - 0.2, 0.25)).multiply(v2(1, mirrorZ))
    );
    fundament.tiefe = 0.7;
    fundament.bodenAbstand = -0.1;
  });
  updateGenericTeil("Schiebetor_Fundament3", Fundament, (fundament: Fundament) => {
    const w = 0.5;
    const b = element.schiebetorFixPunkt["Schiebetor_Entlastungsrolle"].position.x;
    fundament.points = [v2(0, 0), v2(1, 0), v2(1, 1), v2(0, 1)].map((p) =>
      p
        .multiply(v2(w, w))
        .add(v2(b - w / 2, -w / 2))
        .multiply(v2(1, mirrorZ))
    );
    fundament.tiefe = 0.7;
    fundament.bodenAbstand = -0.1;
  });

  updateGenericTeil("Leerrohr", Leerrohr, (leerrohr: Leerrohr) => {
    const xe = eAntriebPosition.x;
    const xe1 = eAntriebPosition.x + 0.05;
    const ze = eAntriebPosition.z;
    const ze1 = eAntriebPosition.z - 0.05 * mirrorZ;
    const xpl = -0.05;
    const zpl = 0;
    const xpr = element.breite;
    const xm = xpr - 0.2;
    const zpr = ze;
    const zpr1 = zpr + 0.24 * mirrorZ;
    const y0 = 0;
    const y1 = -0.2;
    const y2 = -0.7;
    const z2 = -1.5 * mirrorZ;
    leerrohr.paths = [
      [v3(xe, y0, ze1), v3(xe, y1, ze1), v3(xpr, y1, zpr), v3(xpr, y0, zpr)],
      [v3(xe, y0, ze), v3(xe, y1, ze), v3(xpr, y1, zpr1), v3(xpr, y0, zpr1)],
      [v3(xe1, y0, ze), v3(xe1, y2, ze), v3(xpl, y2, zpl), v3(xpl, y0, zpl)],
      [v3(xe1, y0, ze1), v3(xe1, y2, ze1), v3(xm, y2, ze1), v3(xm, y2, z2)],
    ];
  });
}

export function traverseSchiebetorteile(element: ZElement, iterator) {
  const p = element.schiebetorFixPunkt;
  element.schiebetorTranslationsPunkt.traverse(iterator);
  element.schiebetorFixPunkt.traverse(iterator);
  p["Schiebetor_Auflaufschuh"]?.traverse(iterator);
  p["Schiebetor_Einlaufgabel"]?.traverse(iterator);
  p["Schiebetor_Rollenbock1"]?.traverse(iterator);
  p["Schiebetor_Rollenbock2"]?.traverse(iterator);
  p["Schiebetor_Entlastungsrolle"]?.traverse(iterator);
  p["Schiebetor_EAntrieb_Unterbau"]?.traverse(iterator);
  p["Schiebetor_EAntrieb_Came"]?.traverse(iterator);
  p["Schiebetor_Lichtschranke_l1"]?.traverse(iterator);
  p["Schiebetor_Lichtschranke_l2"]?.traverse(iterator);
  p["Schiebetor_Lichtschranke_r1"]?.traverse(iterator);
  p["Schiebetor_Lichtschranke_r2"]?.traverse(iterator);
  p["Schiebetor_Fundament1"]?.traverse(iterator);
  p["Schiebetor_Fundament2"]?.traverse(iterator);
  p["Schiebetor_Fundament3"]?.traverse(iterator);
  p["Leerrohr"]?.traverse(iterator);
}
